// extracted by mini-css-extract-plugin
module.exports = {"root":"_11uwy","pageTitle":"_3hwn7","bottomTextWrapper":"_2D4oc","bottomTextSection":"_2dcHO","section":"_3q002"};